import {
  currencyFormFieldFormatter,
  currencySubmitVariableFormatter,
} from 'app/shared/utils/currencyFormatter';
import { get, getInteger } from 'app/shared/utils/get';

export const errorMsgForField = (field: string, touched: any, errors: any) =>
  get(touched, field, undefined) && get(errors, field, undefined)
    ? get(errors, field, undefined)
    : null;

export const refocusToFirstError = (errors: any, isSubmitting: boolean) => {
  const keys = Object.keys(errors);
  if (keys.length > 0 && isSubmitting) {
    const findFirstErrorElementName = (scopedErrors: any): any => {
      const errorKeys = Object.keys(scopedErrors);

      if (typeof scopedErrors[errorKeys[0]] === 'string') {
        return errorKeys[0];
      }
      return findFirstErrorElementName(scopedErrors[errorKeys[0]]);
    };

    const firstErrorElementName = findFirstErrorElementName(errors);
    const errorElement: HTMLElement | null =
      document.querySelector(`label[for=${firstErrorElementName}]`) ||
      document.querySelector(`[name="${firstErrorElementName}"]`);
    if (errorElement) {
      errorElement.scrollIntoView && errorElement.scrollIntoView();
      errorElement.focus();
    }
  }
};

export const getCurrencyFormInitialValue = (
  data: any,
  path: string,
  currencyCode?: string
) => {
  // TODO: Gradually retrofit all the places we call getCurrencyFormInitialValue to pass in currencyCode -
  // then we can remove the check below and just always call currencyFormFieldFormatter
  const valueFromProps = getInteger(data, path, undefined);
  return valueFromProps || valueFromProps == 0
    ? currencyCode
      ? currencyFormFieldFormatter({
          value: valueFromProps,
          currencyCode,
        })
      : (valueFromProps / 100).toFixed(2)
    : undefined;
};

export const getCurrencyRoundedFormInitialValue = (
  data: any,
  path: string,
  currencyCode?: string
) => {
  // TODO: Gradually retrofit all the places we call getCurrencyRoundedFormInitialValue to pass in currencyCode -
  // then we can remove the check below and just always call currencyFormFieldFormatter
  const valueFromProps = getInteger(data, path, undefined);
  return valueFromProps || valueFromProps == 0
    ? currencyCode
      ? currencyFormFieldFormatter({
          value: valueFromProps,
          currencyCode,
          onlyMajorUnits: true,
        })
      : (valueFromProps / 100).toFixed(0)
    : undefined;
};

export const getCurrencySubmitVariable = (
  value: number | string | null | undefined,
  defaultValue?: number | null,
  currencyCode?: string
) =>
  // TODO: Gradually retrofit all the places we call getCurrencySubmitVariable to pass in currencyCode -
  // then we can remove the check below and just always call currencySubmitVariableFormatter
  value
    ? currencyCode
      ? currencySubmitVariableFormatter({
          value: value ? String(value) : '',
          currencyCode,
        })
      : Number(value) * 100
    : defaultValue || defaultValue == 0
      ? defaultValue
      : null;

export const getIdsSubmitVariable = (ids: number[] | undefined) =>
  ids && ids.length > 0
    ? ids.map((id: number) => String(id)).join(',')
    : undefined;
